import React from 'react';

import './spinner.css'

const Spinner =() => {
    return <div className='Spinner'></div>
}

export default Spinner;